<template>
  <div class="icon-text" :class="[backgroundClass, iconClass]">
    <i :class="'icon icon-' + icon" />
    <div class="text">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "IconText",
  props: {
    icon: {
      type: String,
      required: true,
    },
    useBackground: {
      type: Boolean,
      default: false,
    },
    stack: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    backgroundClass() {
      return this.useBackground ? "icon-text--background" : "";
    },
    iconClass() {
      return this.stack ? "icon-text--stack" : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-text {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;

  &--background {
    background: $color-grey-lightest;
    border-radius: 8px;
  }

  &--stack {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0;
    padding: 28px;
    text-align: center;
  }
}

.icon {
  font-size: 40px;
}

.text {
  @include utility-body(12px);
  text-transform: uppercase;
}
</style>
